import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./new_footer/Footer";
import { routeSharedWithApp } from "../data/routes";

const Layout = () => {
  const location = useLocation();
console.log(location.pathname)
  const hideLayout = routeSharedWithApp.some(
    (route) => route.path === location.pathname
  );

  return (
    <div>
    {!hideLayout &&  <Navbar />}
      <div>
        <Outlet />
      </div>
    {!hideLayout && <Footer />}
    </div>
  );
};
export default Layout;
